import React, { useEffect, useState } from "react";
import Select from "react-select";
import Close from "../../Assets/Close.svg";
import RightSidebarStyle from "./style";
import SvgIcon from "../../Assets/svg-icon.svg";
import PdfIcon from "../../Assets/pdf-icon.svg";
import colorPicker from "../../Assets/color-picker.svg";
import { SketchPicker } from "react-color";
import Modal from "../Modal";
import axios from "axios";

// -- redux
import { connect } from "react-redux";
import { DeleteBank, EditBank, AddBank, CopyBank } from "../../Redux/Actions/BankAction";

function RightSideBar(props) {
  const [response, setResponse] = useState(false);
  const [validated, setValidated] = useState(() => false);
  const [themeTitle, setThemeTitle] = useState("");
  const [bankListData, setBankListData] = useState(() => []);
  const [themeListData, setThemeListData] = useState(() => []);
  //const [Type, setType] = useState("");
  const [themeValue, setThemeValue] = useState([]);
  const [themeId, setThemeId] = useState(0);

  const [bankId, setBankId] = useState(() => "");
  const [bankCode, setBankCode] = useState("");
  const [bankName, setBankName] = useState("");
  const [bankStreet, setBankStreet] = useState("");
  const [bankStreet2, setBankStreet2] = useState("");
  const [bankCity, setBankCity] = useState("");
  const [bankState, setBankState] = useState("");
  const [bankPostalCode, setBankPostalCode] = useState("");
  const [bankPhone, setBankPhone] = useState("");
  const [emailName, setEmailName] = useState("");
  const [Email, setEmail] = useState("");
  const [bankWebSite, setBankWebSite] = useState("");
  const [twitterurl, setTwitterurl] = useState("");
  const [instagramurl, setInstagramurl] = useState("");
  const [tiktokurl, setTiktokurl] = useState("");
  const [linkedinurl, setLinkedinurl] = useState("");
  const [facebookurl, setFacebookurl] = useState("");
  const [logo, setLogo] = useState("");
  const [LogoError, setLogoError] = useState("");
  const [pnglogoSrc, setLogoSrc] = useState("");
  const [header, setHeader] = useState("");
  const [pngHeaderSrc, setHeaderPngSrc] = useState("");
  const [headeImgError, setheadeImgError] = useState("");
  const [base64Icon, setBase64Icon] = useState('');
  const [svgThemeIconImageName, setSvgThemIconImageName] = useState("");
  const [SVGError, setSVGThemIconImageError] = useState("");
  const [OpenModal, setModal] = useState(false);
  const [emailError, setEmailError] = useState("");
  const [ShowTextPicker, setShowTextPicker] = useState(false);
  const [ShowCardPicker, setShowCardPicker] = useState(false);
  const [ShowPrimaryPicker, setShowPrimaryPicker] = useState(false);
  const [ShowBackgroundPicker, setShowBackgroundPicker] = useState(false);
  const [ShowIconPicker, setShowIconPicker] = useState(false);
  const [textColor, setTextColor] = useState("");
  const [cardColor, setCardColor] = useState("");
  const [primaryColor, setPrimaryColor] = useState("");
  const [backgroundColor, setBackgroundColor] = useState("");
  const [iconColor, setIconColor] = useState("");
  const [bankOnfleetApiKey, setBankOnfleetApiKey] = useState("");

  const [bankWebSiteError, setbankWebSiteError] = useState("");
  const [twitterurlError, setTwitterurlError] = useState("");
  const [InstagramurlError, setInstagramurlError] = useState("");
  const [TiktokurlError, setTiktokurlError] = useState("");
  const [LinkedinurlError, setLinkedinurlError] = useState("");
  const [FacebookurlError, setFacebookurlError] = useState("");
  const [copyBankValue, setCopyBankValue] = useState(0);

  function getThemes() {
    return axios.get(`${process.env.REACT_APP_API_URL}api/admin/theme_dropdown_list`, { headers: { bankid: bankId, Authorization: `Bearer ${sessionStorage.getItem("token")}` } }).then((res) => {
      const list = res.data.data;
      const data = list.map((data) => ({ label: data.title, value: data.id }));
    });
  }

  const getBankList = async () => {
    const res = await axios.get(`${process.env.REACT_APP_API_URL}api/admin/banklist`, {
      headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` },
    });
    if (res.status === 200 && res.data && res.data.data) {
      const list = res.data.data;
      const data = list.map((data) => ({ label: data.name, value: data.id }));
      setBankListData(data);
    }
  };

  const colourStyles = {
    control: (styles, state) => ({
      ...styles,
      backgroundColor: "#3C3C3C",
      border: state.isFocused ? "1px solid #A0A0A0" : "1px solid #3C3C3C",
      transition: "all 0.25s linear 0s",
      "&:hover": {
        border: "1px solid #A0A0A0",
      },
      padding: "4px 6px",
      boxShadow: state.isFocused ? null : null,
    }),
    singleValue: (baseStyles, state) => ({
      ...baseStyles,
      color: state.isFocused ? "#ffffff" : "#ffffff",
      backgroundColor: "#3C3C3C",
    }),
  };

  useEffect(() => {
    getBankList();
    if (props.data) {
      setBankId(() => props.data.id);
      setBankCode(props.data.bank_code);
      setBankName(props.data.name);
      setBankStreet(props.data.street);
      setBankStreet2(props.data.street2);
      setBankCity(props.data.city);
      setBankState(props.data.state);
      setBankPostalCode(props.data.postal_code);
      setBankPhone(props.data.phone);
      setEmailName(props.data.from_name);
      setEmail(props.data.from_email);
      setBankWebSite(props.data.web_site_url);
      setTwitterurl(props.data.twitterurl);
      setInstagramurl(props.data.instagramurl);
      setTiktokurl(props.data.tiktokurl);
      setLinkedinurl(props.data.linkedinurl);
      setFacebookurl(props.data.facebookurl);
      setTextColor(props.data.textcolor);
      setCardColor(props.data.cardcolor);
      setPrimaryColor(props.data.primarycolor);
      setBackgroundColor(props.data.backgroundcolor);
      setIconColor(props.data.iconcolor);
      setLogo(props.data.logo);
      setThemeId(props.data.themeid);
      setBankOnfleetApiKey(props.data.onfleet_api_key);
      const data = props.data.themes.map((data) => ({ label: data.title, value: data.id }));
      setThemeListData(data);
    }
  }, [props]);

  const findTheme = (selected) => {
    for (let i = 0; i < themeListData.length; i++) {
      if (themeListData[i].value === selected) {
        return themeListData[i];
      }
    }
  };

  const clearForm = () => {
    setBankCode("");
    setBankName("");
    setBankStreet("");
    setBankStreet2("");
    setBankCity("");
    setBankState("");
    setBankPostalCode("");
    setBankPhone("");
    setEmailName("");
    setEmail("");
    setBankWebSite("");
    setTwitterurl("");
    setInstagramurl("");
    setTiktokurl("");
    setLinkedinurl("");
    setFacebookurl("");
    setTextColor("");
    setCardColor("");
    setPrimaryColor("");
    setBackgroundColor("");
    setIconColor("");
    setThemeTitle("");
    setHeader("");
    setHeaderPngSrc("");
    setSvgThemIconImageName("");
    setBase64Icon("");
    setLogo("");
    setEmailError("");
    setbankWebSiteError("");
    setTwitterurlError("");
    setInstagramurlError("");
    setTiktokurlError("");
    setLinkedinurlError("");
    setFacebookurlError("");
    setBankOnfleetApiKey("");
    setThemeValue([]);
    setThemeListData([]);
    setThemeId(0);
    props.close();
  };

  const CloseSidebar = (e) => {
    e.preventDefault();
    props.close();
  };

  const convertSvgToBase64 = (file, type) => {
    console.log(type);
    const reader = new FileReader();
    reader.onload = (e) => {
    const base64String = e.target.result;
    if (type === "logo") {
        console.log(base64String);
        setLogo(base64String)
    } else if (type === "header") {
        console.log(base64String);
        setHeaderPngSrc(base64String)
    } else {
        console.log(base64String);
        setBase64Icon(base64String)
    }
    };
    reader.onerror = (error) => {
    console.error("Error reading file:", error);
    };
    reader.readAsDataURL(file);
  };

  const handleChange = (e, type) => {
    e.preventDefault();
    if (type === "logo") {
      if (e.target.files[0].size / 1024 < 2000) {
        if (e.target.files[0].type === "image/png") {
          e.target.files[0] && setLogoSrc(e.target.files[0].name);
          e.target.files[0] && convertSvgToBase64(e.target.files[0], type);
          setLogoError("");
        } else {
          setLogoError("Only png is allowed for the logo image.");
        }
      } else {
        setLogoError("File size exceeded for the logo image.");
      }
    }
    if (type === "header") {
      if (e.target.files[0].size / 1024 < 2000) {
        if (e.target.files[0].type === "image/png") {
          e.target.files[0] && setHeader(e.target.files[0].name);
          e.target.files[0] && convertSvgToBase64(e.target.files[0], type);
          setheadeImgError("");
        } else {
          setheadeImgError("Only png is allowed for the header image.");
        }
      } else {
        setheadeImgError("File size exceeds for the headee image.");
      }
    }
    if (type === "svg-theme-icon") {
      if (e.target.files[0].size / 1024 < 2000) {
        if (e.target.files[0].type === "image/svg+xml") {
          e.target.files[0] && setSvgThemIconImageName(e.target.files[0].name);
          e.target.files[0] && convertSvgToBase64(e.target.files[0], type);
          setSVGThemIconImageError("");
        } else {
          setSVGThemIconImageError("Only svg is allowed for the SVG theme image.");
        }
      } else {
        setSVGThemIconImageError("File size exceeded for the SVG theme image.");
      }
    }
  };

  const handleModal = (e, type) => {
    e.preventDefault();
    if (type === "delete") {
      setModal(type);
      return;
    }

    if (type !== "copy_bank") {
      let valid = true;

      valid = checkUrl(bankWebSite, "bankwebsite");
      if (!valid) return;
      valid = checkUrl(twitterurl, "twitterurl");
      if (!valid) return;
      valid = checkUrl(instagramurl, "instagramurl");
      if (!valid) return;
      valid = checkUrl(tiktokurl, "tiktokurl");
      if (!valid) return;
      valid = checkUrl(linkedinurl, "linkedinurl");
      if (!valid) return;
      valid = checkUrl(facebookurl, "facebookurl");
      if (!valid) return;
      let emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/;
      if (!emailRegex.test(Email)) {
        valid = false;
        setEmailError("Invalid email");
        if (type === "delete") {
          setEmailError("");
          setModal(type);
        }
      } else {
        setEmailError("");
      }

      if (valid) setModal(type);
    } else setModal(type);
  };

  function checkUrl(url, name) {
    let expression = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi;
    let regex = new RegExp(expression);
    let expressionHttps = /^https:\/\//;
    let regexHttps = new RegExp(expressionHttps);
    if (!(url.match(regex) && url.match(regexHttps))) {
      switch (name) {
        case "bankwebsite":
          setbankWebSiteError("Invalid URL");
          return false;
        case "twitterurl":
          setTwitterurlError("Invalid URL");
          return false;
        case "instagramurl":
          setInstagramurlError("Invalid URL");
          return false;
        case "tiktokurl":
          setTiktokurlError("Invalid URL");
          return false;
        case "linkedinurl":
          setLinkedinurlError("Invalid URL");
          return false;
        case "facebookurl":
          setFacebookurlError("Invalid URL");
          return false;
      }
    } else {
      switch (name) {
        case "bankwebsite":
          setbankWebSiteError("");
        case "twitterurl":
          setTwitterurlError("");
        case "instagramurl":
          setInstagramurlError("");
        case "tiktokurl":
          setTiktokurlError("");
        case "linkedinurl":
          setLinkedinurlError("");
        case "facebookurl":
          setFacebookurlError("");
      }
    }

    return true;
  }

  useEffect(() => {
    setTimeout(function () {
      setResponse(true);
    }, 1000);
  }, []);

  const CloseModal = (e, type) => {
    e.preventDefault();
    if (type === "copy_bank_yes") {
      const data = {
        name: bankName,
        bank_code: bankCode,
        copyFrom: copyBankValue["value"],
      };
      props.CopyBank(data);
      clearForm();
    }
    if (type === "add_yes") {
      const data = {
        name: bankName,
        bank_code: bankCode,
        street: bankStreet,
        street2: bankStreet2,
        city: bankCity,
        state: bankState,
        postal_code: bankPostalCode,
        phone: bankPhone,
        from_email: Email,
        from_name: emailName,
        logo: logo,
        backgroundcolor: backgroundColor,
        cardcolor: cardColor,
        textcolor: textColor,
        primarycolor: primaryColor,
        iconcolor: iconColor,
        web_site_url: bankWebSite,
        facebookurl: facebookurl,
        twitterurl: twitterurl,
        instagramurl: instagramurl,
        tiktokurl: tiktokurl,
        linkedinurl: linkedinurl,
        themeTitle: themeTitle,
        header_card_image: pngHeaderSrc,
        icon: base64Icon,
        onfleet_api_key: bankOnfleetApiKey
      };
      props.AddBank(data);
      clearForm();
    }
    if (type === "delete_yes") {
      props.DeleteBank(props.data.id);
    }

    if (type === "update_yes") {
      const data = {
        id: props.data.id,
        name: bankName,
        bank_code: bankCode,
        street: bankStreet,
        street2: bankStreet2,
        city: bankCity,
        state: bankState,
        postal_code: bankPostalCode,
        phone: bankPhone,
        from_email: Email,
        from_name: emailName,
        logo: logo,
        backgroundcolor: backgroundColor,
        cardcolor: cardColor,
        textcolor: textColor,
        primarycolor: primaryColor,
        iconcolor: iconColor,
        web_site_url: bankWebSite,
        facebookurl: facebookurl,
        twitterurl: twitterurl,
        instagramurl: instagramurl,
        tiktokurl: tiktokurl,
        linkedinurl: linkedinurl,
        themeid: themeId,
        onfleet_api_key: bankOnfleetApiKey
      };
      props.EditBank(data);
    }
    setModal(false);
  };

  useEffect(() => {
    props.edit_data &&
      response &&
      props.response({
        type: props.edit_data.status,
        message: props.edit_data.message,
      });
  }, [props.edit_data]);

  useEffect(() => {
    props.delete_data &&
      response &&
      props.response({
        type: props.delete_data.status,
        message: props.delete_data.message,
      });
  }, [props.delete_data]);

  useEffect(() => {
    props.add_data &&
      response &&
      props.response({
        type: props.add_data.status,
        message: props.add_data.message,
      });
  }, [props.add_data]);

  useEffect(() => {
    props.copy_data &&
      response &&
      props.response({
        type: props.copy_data.status,
        message: props.copy_data.message,
      });
  }, [props.copy_data]);

  const findBank = (selected) => {
    for (let i = 0; i < bankListData.length; i++) {
      if (bankListData[i].value === selected) {
        return bankListData[i];
      }
    }
  };

  const handleCopyBank = (e) => {
    setCopyBankValue(findBank(e.value));
  };

  const handleTheme = (e) => {
    setThemeId(e.value);
    //findTheme(e.value);
  };

  const copyDisabled = bankCode === "" || bankName === "" || copyBankValue === 0;

  const submitDisabled =
    bankCode === "" ||
    bankName === "" ||
    bankStreet === "" ||
    bankCity === "" ||
    bankState === "" ||
    bankPostalCode === "" ||
    bankPhone === "" ||
    emailName === "" ||
    Email === "" ||
    bankWebSite === "" ||
    twitterurl === "" ||
    instagramurl === "" ||
    tiktokurl === "" ||
    linkedinurl === "" ||
    facebookurl === "" ||
    themeTitle === "" ||
    textColor === "" ||
    cardColor === "" ||
    primaryColor === "" ||
    backgroundColor === "" ||
    iconColor === "" ||
    logo === "" ||
    header === "" ||
    svgThemeIconImageName === "" ||
    base64Icon === "" ||
    bankOnfleetApiKey === "";

  const editSubmitDisabled =
    bankCode === "" ||
    bankName === "" ||
    bankStreet === "" ||
    bankCity === "" ||
    bankState === "" ||
    bankPostalCode === "" ||
    bankPhone === "" ||
    emailName === "" ||
    Email === "" ||
    bankWebSite === "" ||
    twitterurl === "" ||
    instagramurl === "" ||
    tiktokurl === "" ||
    linkedinurl === "" ||
    facebookurl === "" ||
    textColor === "" ||
    cardColor === "" ||
    primaryColor === "" ||
    backgroundColor === "" ||
    iconColor === "" ||
    logo === "" ||
    bankOnfleetApiKey === "";

  return (
    <>
      {props && props.sidebar && <div onClick={(e) => CloseSidebar(e)} className="dark-overlay" />}
      <div className={props && props.sidebar ? "dark-background right-sidebar-wrap" : "dark-background right-sidebar-wrap right-sidebar-wrap-close"}>
        <div className="d-flex justify-content-between align-items-center">
          <h5 className="text-uppercase text-white">{props.Type} BANK</h5>
          <img onClick={(e) => CloseSidebar(e)} src={Close} alt="Close" className="cursor-pointer" />
        </div>
        <form className="sidebar-form-wrap" id="SidebarForm-user" autoComplete="off">
          <div className="mt-4">
            <label htmlFor="BankCode" className="text-grey-6 f-16 d-block mb-1">
              Bank Code <span className="text-danger">*</span>
            </label>
            <input onChange={(e) => setBankCode(e.target.value)} value={bankCode} type="text" id="BankCode" placeholder="Enter Bank Code" className="w-100 input-style" autoComplete="off" maxLength={255} />
          </div>
          <div className="mt-4">
            <label htmlFor="BankName" className="text-grey-6 f-16 d-block mb-1">
              Bank Name <span className="text-danger">*</span>
            </label>
            <input onChange={(e) => setBankName(e.target.value)} value={bankName} type="text" id="BankName" placeholder="Enter Bank Name" className="w-100 input-style" autoComplete="off" maxLength={100} />
          </div>
          <div className="mt-4">
            <label htmlFor="BankOnfleetApiKey" className="text-grey-6 f-16 d-block mb-1">
              Bank Onfleet API Key <span className="text-danger">*</span>
            </label>
            <input onChange={(e) => setBankOnfleetApiKey(e.target.value)} value={bankOnfleetApiKey} type="text" id="BankOnfleetApiKey" placeholder="Enter Bank Onfleet API Key" className="w-100 input-style" autoComplete="off" maxLength={100} />
          </div>
          {props.Type === "Add" && (
            <div className="mt-4">
              <label className="text-grey-6 f-16 d-block mb-1">Copy from an existing bank </label>
              <Select isSearchable={false} options={bankListData} styles={colourStyles} placeholder="Select bank to copy from" onChange={(e) => handleCopyBank(e)} defaultValue={copyBankValue} value={copyBankValue} />
              <div className="mt-5 mb-5 text-center">
                <button className="form-button" onClick={(e) => handleModal(e, "copy_bank")} disabled={copyDisabled}>
                  Copy Now
                </button>
                <label className="text-grey-6 f-16 d-block mb-1">Or complete the form below to manually create a new bank.</label>
              </div>
            </div>
          )}
          {props.Type === "Edit" && (
            <div className="mt-4">
              <label className="text-grey-6 f-16 d-block mb-1">
                Default Theme <span className="text-danger">*</span>
              </label>
              <Select isSearchable={false} options={themeListData} styles={colourStyles} placeholder="Select Theme" onChange={(e) => handleTheme(e)} defaultValue={findTheme(themeId)} value={findTheme(themeId)} />
            </div>
          )}

          <div className="mt-4">
            <label htmlFor="BankStreet" className="text-grey-6 f-16 d-block mb-1">
              Street <span className="text-danger">*</span>
            </label>
            <input onChange={(e) => setBankStreet(e.target.value)} value={bankStreet} type="text" id="BankStreet" placeholder="Enter Street Address" className="w-100 input-style" autoComplete="off" maxLength={100} />
          </div>
          <div className="mt-4">
            <input onChange={(e) => setBankStreet2(e.target.value)} value={bankStreet2} type="text" id="BankStreet2" placeholder="Suite or Building No." className="w-100 input-style" autoComplete="off" maxLength={100} />
          </div>
          <div className="mt-4">
            <label htmlFor="BankCity" className="text-grey-6 f-16 d-block mb-1">
              City <span className="text-danger">*</span>
            </label>
            <input onChange={(e) => setBankCity(e.target.value)} value={bankCity} type="text" id="BankCity" placeholder="Enter City" className="w-100 input-style" autoComplete="off" maxLength={100} />
          </div>
          <div className="mt-4">
            <label htmlFor="BankState" className="text-grey-6 f-16 d-block mb-1">
              State <span className="text-danger">*</span>
            </label>
            <input onChange={(e) => setBankState(e.target.value)} value={bankState} type="text" id="BankState" placeholder="Enter State" className="w-100 input-style" autoComplete="off" maxLength={100} />
          </div>
          <div className="mt-4">
            <label htmlFor="BankPostalCode" className="text-grey-6 f-16 d-block mb-1">
              Postal Code <span className="text-danger">*</span>
            </label>
            <input onChange={(e) => setBankPostalCode(e.target.value)} value={bankPostalCode} type="text" id="BankPostalCode" placeholder="Enter Postal Code" className="w-100 input-style" autoComplete="off" maxLength={20} />
          </div>
          <div className="mt-4">
            <label htmlFor="BankPhone" className="text-grey-6 f-16 d-block mb-1">
              Phone <span className="text-danger">*</span>
            </label>
            <input onChange={(e) => setBankPhone(e.target.value)} value={bankPhone} type="text" id="email" placeholder="Enter Phone Number" className="w-100 input-style" autoComplete="off" maxLength={100} />
          </div>
          <div className="mt-4">
            <label htmlFor="emailName" className="text-grey-6 f-16 d-block mb-1">
              Email Name <span className="text-danger">*</span>
            </label>
            <input onChange={(e) => setEmailName(e.target.value)} value={emailName} type="text" id="emailName" placeholder="Enter Email Owner Name" className="w-100 input-style" autoComplete="off" maxLength={100} />
          </div>
          <div className="mt-4">
            <label htmlFor="email" className="text-grey-6 f-16 d-block mb-1">
              Email Address <span className="text-danger">*</span>
            </label>
            <input value={Email} onChange={(e) => setEmail(e.target.value)} type="text" id="email" placeholder="Enter Email Address" className="w-100 input-style" autoComplete="off" />
            {emailError && <span className="f-12 text-danger">{emailError}</span>}
          </div>
          <div className="mt-4">
            <label htmlFor="BankWebSite" className="text-grey-6 f-16 d-block mb-1">
              Web Site URL <span className="text-danger">*</span>
            </label>
            <input onChange={(e) => setBankWebSite(e.target.value)} value={bankWebSite} type="text" id="BankWebSite" placeholder="Enter Web Site URL" className="w-100 input-style" autoComplete="off" maxLength={100} />
            {bankWebSiteError && <span className="f-12 text-danger">{bankWebSiteError}</span>}
          </div>
          <div className="mt-4">
            <label htmlFor="twitterurl" className="text-grey-6 f-16 d-block mb-1">
              Twitter URL <span className="text-danger">*</span>
            </label>
            <input onChange={(e) => setTwitterurl(e.target.value)} value={twitterurl} type="text" id="twitterurl" placeholder="Enter Twitter URL" className="w-100 input-style" autoComplete="off" maxLength={255} />
            {twitterurlError && <span className="f-12 text-danger">{twitterurlError}</span>}
          </div>
          <div className="mt-4">
            <label htmlFor="instagramurl" className="text-grey-6 f-16 d-block mb-1">
              Instagram URL <span className="text-danger">*</span>
            </label>
            <input onChange={(e) => setInstagramurl(e.target.value)} value={instagramurl} type="text" id="instagramurl" placeholder="Enter Instagram URL" className="w-100 input-style" autoComplete="off" maxLength={255} />
            {InstagramurlError && <span className="f-12 text-danger">{InstagramurlError}</span>}
          </div>
          <div className="mt-4">
            <label htmlFor="tiktokurl" className="text-grey-6 f-16 d-block mb-1">
              Tik Tok URL <span className="text-danger">*</span>
            </label>
            <input onChange={(e) => setTiktokurl(e.target.value)} value={tiktokurl} type="text" id="tiktokurl" placeholder="Enter Tik Tok URL" className="w-100 input-style" autoComplete="off" maxLength={255} />
            {TiktokurlError && <span className="f-12 text-danger">{TiktokurlError}</span>}
          </div>
          <div className="mt-4">
            <label htmlFor="linkedinurl" className="text-grey-6 f-16 d-block mb-1">
              Linked In URL <span className="text-danger">*</span>
            </label>
            <input onChange={(e) => setLinkedinurl(e.target.value)} value={linkedinurl} type="text" id="linkedinurl" placeholder="Enter Linked In URL" className="w-100 input-style" autoComplete="off" maxLength={255} />
            {LinkedinurlError && <span className="f-12 text-danger">{LinkedinurlError}</span>}
          </div>
          <div className="mt-4">
            <label htmlFor="facebookurl" className="text-grey-6 f-16 d-block mb-1">
              Facebook URL <span className="text-danger">*</span>
            </label>
            <input onChange={(e) => setFacebookurl(e.target.value)} value={facebookurl} type="text" id="facebookurl" placeholder="Enter Facebook URL" className="w-100 input-style" autoComplete="off" maxLength={255} />
            {FacebookurlError && <span className="f-12 text-danger">{FacebookurlError}</span>}
          </div>
          {props.Type === "Add" && (
            <div className="mt-4Center action-wrap">
              <div className="mt-4">
                <label htmlFor="themeTitle" className="text-grey-6 f-16 d-block mb-1">
                  Theme Title <span className="text-danger">*</span>
                </label>
                <input type="text" placeholder="Enter theme title" className="w-100" onChange={(e) => setThemeTitle(e.target.value)} value={themeTitle} />
              </div>

              <label htmlFor="headerBackground" className="text-grey-6 f-16 d-block mb-1">
                Header Background <span className="text-danger">*</span>
              </label>
              <label className="custom-file-upload-center w-50 position-relative d-flex align-items-center justify-content-center mb-0" title={header}>
                <input className="d-none" type="file" accept="image/png" onClick={(e) => (e.target.value = null)} onChange={(e) => handleChange(e, "header")} />
                <div className="width-50">
                  {pngHeaderSrc !== "" ? (
                    <img src={pngHeaderSrc} alt="svg-icon" style={{ width: '30%', height: '30%', objectFit: 'contain' }} />
                  ) : (
                    <>
                      <span>Click to browse</span>
                      <br />
                      <br />
                      <p>Upload PNG for Header</p>
                    </>
                  )}
                  {pngHeaderSrc !== "" && <p className="text-white mb-0 mt-1 col-12 text-truncate m-auto">{header}</p>}
                  {pngHeaderSrc !== "" && (
                    <div
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setHeader("");
                        setHeaderPngSrc("");
                      }}
                      className="remove-button"
                    >
                      <p className="text-uppercase mb-0 text-white">Remove</p>
                    </div>
                  )}
                </div>
              </label>
              {headeImgError && <p className="text-danger f-12">{headeImgError}</p>}
              <br />
              <label htmlFor="headerBackground" className="text-grey-6 f-16 d-block mb-1">
                Theme Icon <span className="text-danger">*</span>
              </label>
              <div class="flex-container">
                <label className="small-custom-file-upload-center w-50 position-relative d-flex align-items-center justify-content-center mb-0 flex-item">
                  <input className="d-none" type="file" accept="image/svg+xml" onClick={(e) => (e.target.value = null)} onChange={(e) => handleChange(e, "svg-theme-icon")} />
                  <div className="width-50">
                    {base64Icon !== "" ? (
                      <img src={base64Icon} alt="svg-icon" style={{ width: '30%', height: '30%', objectFit: 'contain' }}/>
                    ) : (
                      <>
                        <span>Click to browse</span>
                        <br />
                        <br />
                        <p>Upload SVG</p>
                      </>
                    )}
                    {base64Icon !== "" && <p className="text-white mb-0 mt-1 col-12 text-truncate m-auto">{svgThemeIconImageName}</p>}
                    {base64Icon !== "" && (
                      <div
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          setSvgThemIconImageName("");
                          setBase64Icon("");
                        }}
                        className="remove-button"
                      >
                        <p className="text-uppercase mb-0 tThemIconImageext-white">Remove</p>
                      </div>
                    )}
                  </div>
                </label>
              </div>
            </div>
          )}
          <div className="mt-4">
            <label htmlFor="textColor" className="text-grey-6 f-16 d-block mb-1">
              Text Color <span className="text-danger">*</span>
            </label>
            <input style={{ background: `url(${colorPicker})` }} type="text" placeholder="Select or Enter text color" className="w-100 color-picker" onClick={() => setShowTextPicker(!ShowTextPicker)} value={textColor === "" ? textColor : textColor} />
            {ShowTextPicker && (
              <div className="position-absolute color-picker-wrap">
                <SketchPicker color={textColor} onChange={(e) => setTextColor(e.hex)} />
                <div onClick={() => setShowTextPicker(!ShowTextPicker)} className="overlay position-fixed" />
              </div>
            )}
          </div>
          <div className="mt-4">
            <label htmlFor="cardColor" className="text-grey-6 f-16 d-block mb-1">
              Card Color <span className="text-danger">*</span>
            </label>
            <input style={{ background: `url(${colorPicker})` }} type="text" placeholder="Select or Enter card color" className="w-100 color-picker" onClick={() => setShowCardPicker(!ShowCardPicker)} value={cardColor === "" ? cardColor : cardColor} />
            {ShowCardPicker && (
              <div className="position-absolute color-picker-wrap">
                <SketchPicker color={cardColor} onChange={(e) => setCardColor(e.hex)} />
                <div onClick={() => setShowCardPicker(!ShowCardPicker)} className="overlay position-fixed" />
              </div>
            )}
          </div>
          <div className="mt-4">
            <label htmlFor="primaryColor" className="text-grey-6 f-16 d-block mb-1">
              Primary Color <span className="text-danger">*</span>
            </label>
            <input style={{ background: `url(${colorPicker})` }} type="text" placeholder="Select or Enter primary color" className="w-100 color-picker" onClick={() => setShowPrimaryPicker(!ShowPrimaryPicker)} value={primaryColor === "" ? primaryColor : primaryColor} />
            {ShowPrimaryPicker && (
              <div className="position-absolute color-picker-wrap">
                <SketchPicker color={primaryColor} onChange={(e) => setPrimaryColor(e.hex)} />
                <div onClick={() => setShowPrimaryPicker(!ShowPrimaryPicker)} className="overlay position-fixed" />
              </div>
            )}
          </div>
          <div className="mt-4">
            <label htmlFor="backgroundColor" className="text-grey-6 f-16 d-block mb-1">
              Background Color <span className="text-danger">*</span>
            </label>
            <input style={{ background: `url(${colorPicker})` }} type="text" placeholder="Select or Enter background color" className="w-100 color-picker" onClick={() => setShowBackgroundPicker(!ShowBackgroundPicker)} value={backgroundColor === "" ? backgroundColor : backgroundColor} />
            {ShowBackgroundPicker && (
              <div className="position-absolute color-picker-wrap">
                <SketchPicker color={backgroundColor} onChange={(e) => setBackgroundColor(e.hex)} />
                <div onClick={() => setShowBackgroundPicker(!ShowBackgroundPicker)} className="overlay position-fixed" />
              </div>
            )}
          </div>

          <div className="mt-4">
            <label htmlFor="iconColor" className="text-grey-6 f-16 d-block mb-1">
              Icon Color <span className="text-danger">*</span>
            </label>
            <input style={{ background: `url(${colorPicker})` }} type="text" placeholder="Select or Enter icon color" className="w-100 color-picker" onClick={() => setShowIconPicker(!ShowIconPicker)} value={iconColor === "" ? iconColor : iconColor} />
            {ShowIconPicker && (
              <div className="position-absolute color-picker-wrap">
                <SketchPicker color={iconColor} onChange={(e) => setIconColor(e.hex)} />
                <div onClick={() => setShowIconPicker(!ShowIconPicker)} className="overlay position-fixed" />
              </div>
            )}
          </div>
          <br />
          <label htmlFor="headerBackground" className="text-grey-6 f-16 d-block mb-1">
            Bank Logo <span className="text-danger">*</span>
          </label>
          <label className="custom-file-upload-center w-50 position-relative d-flex align-items-center justify-content-center mb-0" title={logo}>
            <input className="d-none" type="file" accept="image/png" onClick={(e) => (e.target.value = null)} onChange={(e) => handleChange(e, "logo")} />
            <div className="width-50">
              {logo !== "" ? (
                <img src={logo} alt="svg-icon" style={{ width: '30%', height: '30%', objectFit: 'contain' }}/>
              ) : (
                <>
                  <span>Click to browse</span>
                  <br />
                  <br />
                  <p>Upload PNG for Logo</p>
                </>
              )}
              {logo !== "" && <p className="text-white mb-0 mt-1 col-12 text-truncate m-auto">{pnglogoSrc}</p>}
              {logo !== "" && (
                <div
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setLogo("");
                    setLogo("");
                  }}
                  className="remove-button"
                >
                  <p className="text-uppercase mb-0 text-white">Remove</p>
                </div>
              )}
            </div>
          </label>
          {LogoError && <p className="text-danger f-12">{LogoError}</p>}
          <br />
          <div className="mt-5 mb-5 text-center">
            {props.Type === "Add" && (
              <button onClick={(e) => handleModal(e, "add")} className="form-button" disabled={submitDisabled}>
                Save
              </button>
            )}
            {props.Type === "Edit" && (
              <div className="d-flex align-items-center justify-content-center">
                <button onClick={(e) => handleModal(e, "delete")} className="form-button form-button-ghost f-14 mr-2">
                  Delete
                </button>
                <button disabled={editSubmitDisabled} onClick={(e) => handleModal(e, "update")} className="form-button ml-2 f-14">
                  Update
                </button>
              </div>
            )}
          </div>
        </form>
      </div>
      {OpenModal && <Modal Name={bankName} Type={OpenModal} Close={(e, type) => CloseModal(e, type)} />}
      <RightSidebarStyle />
    </>
  );
}

const mapStateToProps = ({ GetBankReducer }) => {
  const { loading, delete_data, add_data, edit_data, copy_data } = GetBankReducer;
  return {
    loading,
    delete_data,
    add_data,
    edit_data,
    copy_data,
  };
};

const mapDispatchToProps = {
  DeleteBank,
  EditBank,
  AddBank,
  CopyBank,
};

export default connect(mapStateToProps, mapDispatchToProps)(RightSideBar);
